import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'app-tour-menutab',
  templateUrl: './tour-menutab.component.html',
  styleUrls: ['./tour-menutab.component.css']
})
export class TourMenutabComponent implements AfterViewInit {
  @Input() isEdit: boolean = false;
  @Input() nameMenu: string = '';
  @Input() branchofficeSlug: string = '';
  @Input() checkId: any = '';

  constructor() {}

  ngAfterViewInit(): void {}
}
